
const events = [
    'initialize',
    'initialized',
    'resize',
    'resized',
    'refresh',
    'refreshed',
    'update',
    'updated',
    'drag',
    'dragged',
    'translate',
    'translated',
    'to',
    'changed',
];
const styleMapping = {
    y: {
        t: 'top',
        m: 'marginTop',
        b: 'bottom',
    },
    x: {
        l: 'left',
        m: 'marginLeft',
        r: 'right',
    }
};

Vue.component('carousel', {
    template: `
    <div>
    <span v-show="showPrev" :id="prevHandler">
      <slot name="prev" />
    </span>
    <div :id="elementHandle" :class="['owl-carousel', 'owl-theme']">
      <slot />
    </div>
    <span v-show="showNext" :id="nextHandler">
      <slot name="next" />
    </span>
  </div>
    `,
    props: {
        items: {
            type: Number,
            default: 3,
        },
        margin: {
            type: Number,
            default: 0,
        },
        loop: {
            type: Boolean,
            default: false,
        },
        center: {
            type: Boolean,
            default: false,
        },
        mouseDrag: {
            type: Boolean,
            default: true,
        },
        touchDrag: {
            type: Boolean,
            default: true,
        },
        pullDrag: {
            type: Boolean,
            default: true,
        },
        freeDrag: {
            type: Boolean,
            default: false,
        },
        stagePadding: {
            type: Number,
            default: 0,
        },
        merge: {
            type: Boolean,
            default: false,
        },
        mergeFit: {
            type: Boolean,
            default: false,
        },
        autoWidth: {
            type: Boolean,
            default: false,
        },
        startPosition: {
            type: Number,
            default: 0,
        },
        uRLhashListener: {
            type: Boolean,
            default: false,
        },
        nav: {
            type: Boolean,
            default: true,
        },
        rewind: {
            type: Boolean,
            default: true,
        },
        navText: {
            type: Array,
            default: () => ['next', 'prev'],
        },
        navElement: {
            type: String,
            default: 'div',
        },
        slideBy: {
            type: [Number, String],
            default: 1,
        },
        slideTransition: {
            type: String,
            default: '',
        },
        dots: {
            type: Boolean,
            default: true,
        },
        dotsEach: {
            type: [Number, Boolean],
            default: false,
        },
        dotsData: {
            type: Boolean,
            default: false,
        },
        lazyLoad: {
            type: Boolean,
            default: false,
        },
        lazyLoadEager: {
            type: Number,
            default: 0,
        },
        autoplay: {
            type: Boolean,
            default: false,
        },
        autoplaySpeed: {
            type: Boolean,
            default: false,
        },
        autoplayTimeout: {
            type: Number,
            default: 5000,
        },
        autoplayHoverPause: {
            type: Boolean,
            default: false,
        },
        smartSpeed: {
            type: Number,
            default: 250,
        },
        fluidSpeed: {
            type: [Number, Boolean],
            default: false,
        },
        navSpeed: {
            type: [Number, Boolean],
            default: false,
        },
        dragEndSpeed: {
            type: [Number, Boolean],
            default: false,
        },
        callbacks: {
            type: Boolean,
            default: true,
        },
        responsive: {
            type: Object,
            default: () => { },
        },
        responsiveRefreshRate: {
            type: Number,
            default: 200,
        },
        video: {
            type: Boolean,
            default: false,
        },
        videoHeight: {
            type: [Number, Boolean],
            default: false,
        },
        videoWidth: {
            type: [Number, Boolean],
            default: false,
        },
        animateOut: {
            type: [String, Boolean],
            default: false,
        },
        animateIn: {
            type: [String, Boolean],
            default: false,
        },
        fallbackEasing: {
            type: String,
            default: 'swing',
        },
        info: {
            type: Function,
            default: () => { },
        },
        itemElement: {
            type: String,
            default: 'div',
        },
        stageElement: {
            type: String,
            default: 'div',
        },
        navContainer: {
            type: [String, Boolean],
            default: false,
        },
        dotsContainer: {
            type: [String, Boolean],
            default: false,
        },
        checkVisible: {
            type: Boolean,
            default: true,
        },
    },
    data: function () {
        return {
            showPrev: false,
            showNext: true,

            prevHandler: 'carousel_prev_' + this.generateUniqueId(),
            elementHandle: 'carousel_' + this.generateUniqueId(),
            nextHandler: 'carousel_next_' + this.generateUniqueId(),
        };
    },

    mounted: function () {
        const owl = $('#' + this.elementHandle).owlCarousel({
            items: this.items,
            margin: this.margin,
            loop: this.loop,
            center: this.center,
            mouseDrag: this.mouseDrag,
            touchDrag: this.touchDrag,
            pullDrag: this.pullDrag,
            freeDrag: this.freeDrag,
            stagePadding: this.stagePadding,
            merge: this.merge,
            mergeFit: this.mergeFit,
            autoWidth: this.autoWidth,
            startPosition: this.startPosition,
            uRLhashListener: this.uRLhashListener,
            nav: this.nav,
            rewind: this.rewind,
            navText: this.navText,
            navElement: this.navElement,
            slideBy: this.slideBy,
            slideTransition: this.slideTransition,
            dots: this.dots,
            dotsEach: this.dotsEach,
            dotsData: this.dotsData,
            lazyLoad: this.lazyLoad,
            lazyLoadEager: this.lazyLoadEager,
            autoplay: this.autoplay,
            autoplaySpeed: this.autoplaySpeed,
            autoplayTimeout: this.autoplayTimeout,
            autoplayHoverPause: this.autoplayHoverPause,
            smartSpeed: this.smartSpeed,
            fluidSpeed: this.fluidSpeed,
            navSpeed: this.navSpeed,
            dragEndSpeed: this.dragEndSpeed,
            callbacks: this.callbacks,
            responsive: this.responsive,
            responsiveRefreshRate: this.responsiveRefreshRate,
            video: this.video,
            videoHeight: this.videoHeight,
            videoWidth: this.videoWidth,
            animateOut: this.animateOut,
            animateIn: this.animateIn,
            fallbackEasing: this.fallbackEasing,
            info: this.info,
            itemElement: this.itemElement,
            stageElement: this.stageElement,
            navContainer: this.navContainer,
            dotsContainer: this.dotsContainer,
            checkVisible: this.checkVisible,
        });

        $('#' + this.prevHandler).click(function () {
            owl.trigger('prev.owl.carousel');
        });

        $('#' + this.nextHandler).click(function () {
            owl.trigger('next.owl.carousel');
        });

        events.forEach((eventName) => {
            owl.on(`${eventName}.owl.carousel`, (event) => {
                this.$emit(eventName, event);
            });
        });

        if (!this.loop) {
            owl.on('changed.owl.carousel', (event) => {
                // start
                if (event.item.index === 0) {
                    this.showPrev = false;
                    this.showNext = true;
                } else {
                    const currnetel = Math.floor(event.item.index + event.page.size);
                    // last
                    if (currnetel === event.item.count) {
                        this.showPrev = true;
                        this.showNext = false;
                    } else {
                        this.showPrev = true;
                        this.showNext = true;
                    }
                }
            });
        }
    },

    methods: {
        generateUniqueId() {
            return Math.random().toString(36).substring(2, 15);
        },
    }
})

Vue.component('vuedragresize', {
  template: `
	<div class="vdr" 
	 :style="style"
     :class="[
		(active || isActive) ? 'active' : 'inactive',
		contentClass
	 ]"
     @mousedown="bodyDown($event)"
     @touchstart="bodyDown($event)"
     @touchend="up($event)">
    <slot></slot>
    <div
            v-for="stick in sticks"
            class="vdr-stick"
            :class="['vdr-stick-' + stick, isResizable ? '' : 'not-resizable']"
            @mousedown.stop.prevent="stickDown(stick, $event)"
            @touchstart.stop.prevent="stickDown(stick, $event)"
            :style="vdrStick(stick)">
    </div>

</div>`,
  props: {
        stickSize: {
          type: Number, default: 8,
        },
        parentScaleX: {
            type: Number, default: 1,
        },
        parentScaleY: {
            type: Number, default: 1,
        },
        isActive: {
            type: Boolean, default: false
        },
    	active: {
            type: Boolean, default: false
        },
        preventActiveBehavior: {
            type: Boolean, default: false
        },
        isDraggable: {
            type: Boolean, default: true
        },
        isResizable: {
            type: Boolean, default: true
        },
        aspectRatio: {
            type: Boolean, default: false
        },
        parentLimitation: {
            type: Boolean, default: false
        },
        snapToGrid: {
            type: Boolean, default: false
        },
        gridX: {
            type: Number,
            default: 50,
            validator: function (val) {
                return val > 0
            }
        },
        gridY: {
            type: Number,
            default: 50,
            validator: function (val) {
                return val > 0
            }
        },
        parentW: {
            type: Number,
            default: 0,
            validator: function (val) {
                return val >= 0
            }
        },
        parentH: {
            type: Number,
            default: 0,
            validator: function (val) {
                return val >= 0
            }
        },
    	
    	w: {
            type: Number,
            default: 100,
            validator: function (val) {
                return val > 0
            }
        },
        h: {
            type: Number,
            default: 100,
            validator: function (val) {
                return val > 0
            }
        },
    	width: {
            type: Number,
            default: 100,
            validator: function (val) {
                return val > 0
            }
        },
        height: {
            type: Number,
            default: 100,
            validator: function (val) {
                return val > 0
            }
        },
        minw: {
            type: Number,
            default: 50,
            validator: function (val) {
                return val > 0
            }
        },
        minh: {
            type: Number,
            default: 50,
            validator: function (val) {
                return val > 0
            }
        },
        x: {
            type: Number,
            default: 0,
            validator: function (val) {
                return typeof val === 'number'
            }
        },
    	top: {
            type: Number,
            default: 0,
            validator: function (val) {
                return typeof val === 'number'
            }
        },
        y: {
            type: Number,
            default: 0,
            validator: function (val) {
                return typeof val === 'number'
            }
        },
    	left: {
            type: Number,
            default: 0,
            validator: function (val) {
                return typeof val === 'number'
            }
        },
    	bottom: {
            type: Number,
            default: 0,
            validator: function (val) {
                return typeof val === 'number'
            }
        },
    	right: {
            type: Number,
            default: 0,
            validator: function (val) {
                return typeof val === 'number'
            }
        },
        z: {
            type: [String, Number],
            default: 'auto',
            validator: function (val) {
                let valid = (typeof val === 'string') ? val === 'auto' : val >= 0;
                return valid
            }
        },
        dragHandle: {
            type: String,
            default: null
        },
        dragCancel: {
            type: String,
            default: null
        },
        id: {
          type: String,
          default: null
        },
        sticks: {
            type: Array,
            default: function () {
                return ['tl', 'tm', 'tr', 'mr', 'br', 'bm', 'bl', 'ml']
            }
        },
        axis: {
            type: String,
            default: 'both',
            validator: function (val) {
                return ['x', 'y', 'both', 'none'].indexOf(val) !== -1
            }
        },
        contentClass: {
            type: String,
            required: false, 
            default: ""
        }
    },

  
    created: function () {
        this.stickDrag = false;
        this.bodyDrag = false;
        this.stickAxis = null;
      	this.stickSize = this.$attrs.sticksize;
        this.stickStartPos = {mouseX: 0, mouseY: 0, x: 0, y: 0, w: 0, h: 0};
        this.limits = {
            minLeft: null,
            maxLeft: null,
            minRight: null,
            maxRight: null,
            minTop: null,
            maxTop: null,
            minBottom: null,
            maxBottom: null
        };
      	this.id = this.$attrs.id;
      	
        this.currentStick = [];
      
    },

    mounted: function () {
        this.parentElement = this.$el.parentNode;
        var rect = {
          top: this.x,
          left: this.y,
          height: this.h,
          width: this.w
        }
        this.left = rect.left;
      	this.top = rect.top;

      	this.right = this.left + rect.width;
      	this.bottom = this.top + rect.height;
        this.$emit('resizing', rect);

        this.parentWidth = this.parentW ? this.parentW : this.parentElement.clientWidth;
        this.parentHeight = this.parentH ? this.parentH : this.parentElement.clientHeight;

        this.rawRight = this.parentWidth - this.rawWidth - this.rawLeft;
        this.rawBottom = this.parentHeight - this.rawHeight - this.rawTop;

        document.documentElement.addEventListener('mousemove', this.move);
        document.documentElement.addEventListener('mouseup', this.up);
        document.documentElement.addEventListener('mouseleave', this.up);

        document.documentElement.addEventListener('mousedown', this.deselect);

        document.documentElement.addEventListener('touchmove', this.move, true);
        document.documentElement.addEventListener('touchend', this.up, true);
        document.documentElement.addEventListener('touchcancel', this.up, true);
        document.documentElement.addEventListener('touchstart', this.up, true);

        if (this.dragHandle) {
            let dragHandles = Array.prototype.slice.call(this.$el.querySelectorAll(this.dragHandle));
            for (let i in dragHandles) {
                dragHandles[i].setAttribute('data-drag-handle', this._uid);
            }
        }

        if (this.dragCancel) {
            let cancelHandles = Array.prototype.slice.call(this.$el.querySelectorAll(this.dragCancel));
            for (let i in cancelHandles) {
                cancelHandles[i].setAttribute('data-drag-cancel', this._uid);
            }
        }
      
      	this.$emit('setBeginningParams', this);
      
    },

    beforeDestroy: function () {
        document.documentElement.removeEventListener('mousemove', this.move);
        document.documentElement.removeEventListener('mouseup', this.up);
        document.documentElement.removeEventListener('mouseleave', this.up);

        document.documentElement.removeEventListener('mousedown', this.deselect);

        document.documentElement.removeEventListener('touchmove', this.move, true);
        document.documentElement.removeEventListener('touchend', this.up, true);
        document.documentElement.removeEventListener('touchcancel', this.up, true);
        document.documentElement.removeEventListener('touchstart', this.up, true);
    },

    methods: {
        deselect() {
            if (this.preventActiveBehavior) {
                return
            }
            this.active = false
        },

        move(ev) {
            if (!this.stickDrag && !this.bodyDrag) {
                return
            }
            ev.stopPropagation();

            if (this.stickDrag) {
                this.stickMove(ev);
            }
            if (this.bodyDrag) {
                this.bodyMove(ev)
            }
        },

        up(ev) {
            if (this.stickDrag) {
                this.stickUp(ev);
            }
            if (this.bodyDrag) {
                this.bodyUp(ev)
            }
        },

        bodyDown: function (ev) {
            let target = ev.target || ev.srcElement;

            if (!this.preventActiveBehavior) {
                this.active = true;
            }

            if (ev.button && ev.button !== 0) {
                return
            }

            this.$emit('clicked', ev);

            if (!this.active) {
                return
            }
            
            if (this.dragHandle && target.getAttribute('data-drag-handle') !== this._uid.toString()) {
                return
            }

            if (this.dragCancel && target.getAttribute('data-drag-cancel') === this._uid.toString()) {
                return
            }

            ev.stopPropagation();
            ev.preventDefault();

            if (this.isDraggable) {
                this.bodyDrag = true;
            }

            this.stickStartPos.mouseX = typeof ev.pageX !== 'undefined' ? ev.pageX : ev.touches[0].pageX;
            this.stickStartPos.mouseY = typeof ev.pageY !== 'undefined' ? ev.pageY : ev.touches[0].pageY;

            this.stickStartPos.left = this.left;
            this.stickStartPos.right = this.right;
            this.stickStartPos.top = this.top;
            this.stickStartPos.bottom = this.bottom;
            if (this.parentLimitation) {
                this.limits = this.calcDragLimitation();
            }
        },

        calcDragLimitation() {
            const parentWidth = this.parentWidth;
            const parentHeight = this.parentHeight;

            return {
                minLeft: 0,
                maxLeft: parentWidth - this.width,
                minRight: 0,
                maxRight: parentWidth - this.width,
                minTop: 0,
                maxTop: parentHeight - this.height,
                minBottom: 0,
                maxBottom: parentHeight - this.height
            }
        },

        bodyMove(ev) {
            const stickStartPos = this.stickStartPos;
            const parentWidth = this.parentWidth;
            const parentHeight = this.parentHeight;
            const gridX = this.gridX;
            const gridY = this.gridY;
            const width = this.width;
            const height = this.height;
            const pageX = typeof ev.pageX !== 'undefined' ? ev.pageX : ev.touches[0].pageX;
            const pageY = typeof ev.pageY !== 'undefined' ? ev.pageY : ev.touches[0].pageY;

            let delta = {
                x: (this.axis !== 'y' && this.axis !== 'none' ? stickStartPos.mouseX - pageX : 0) / this.parentScaleX,
                y: (this.axis !== 'x' && this.axis !== 'none' ? stickStartPos.mouseY - pageY : 0) / this.parentScaleY
            };

            let newTop = stickStartPos.top - delta.y;
//             let newBottom = stickStartPos.bottom + delta.y;
          let newBottom = stickStartPos.bottom - delta.y;
            let newLeft = stickStartPos.left - delta.x;
//             let newRight = stickStartPos.right + delta.x;
          let newRight = stickStartPos.right - delta.x;

          
            if (this.snapToGrid) {
                let alignTop = true;
                let alignLeft = true;

                let diffT = newTop - Math.floor(newTop / gridY) * gridY;
                let diffB = (parentHeight - newBottom) - Math.floor((parentHeight - newBottom) / gridY) * gridY;
                let diffL = newLeft - Math.floor(newLeft / gridX) * gridX;
                let diffR = (parentWidth - newRight) - Math.floor((parentWidth - newRight) / gridX) * gridX;

                if (diffT > (gridY / 2)) { diffT = diffT - gridY; }
                if (diffB > (gridY / 2)) { diffB = diffB - gridY; }
                if (diffL > (gridX / 2)) { diffL = diffL - gridX; }
                if (diffR > (gridX / 2)) { diffR = diffR - gridX; }

                if (Math.abs(diffB) < Math.abs(diffT)) { alignTop = false; }
                if (Math.abs(diffR) < Math.abs(diffL)) { alignLeft = false; }

                newTop = newTop - (alignTop ? diffT : diffB);
                newBottom = parentHeight - height - newTop;
                newLeft = newLeft - (alignLeft ? diffL : diffR);
                newRight = parentWidth - width - newLeft;
            }

            this.rawTop = newTop;
            this.rawBottom = newBottom;
            this.rawLeft = newLeft;
            this.rawRight = newRight;
          
          	this.setNewLeft(newLeft);
          	this.setNewTop(newTop);
          	this.setNewRight(newRight);
          	this.setNewBottom(newBottom);
          
            this.$emit('dragging', this.rect);
        },

        bodyUp() {
            this.bodyDrag = false;
            this.$emit('dragging', this.rect);
            this.$emit('dragstop', this.rect);

            this.stickStartPos = {mouseX: 0, mouseY: 0, x: 0, y: 0, w: 0, h: 0};
            this.limits = {
                minLeft: null,
                maxLeft: null,
                minRight: null,
                maxRight: null,
                minTop: null,
                maxTop: null,
                minBottom: null,
                maxBottom: null
            };
        },

        stickDown: function (stick, ev) {
            if (!this.isResizable || !this.active) {
                return
            }

            this.stickDrag = true;
            this.stickStartPos.mouseX = typeof ev.pageX !== 'undefined' ? ev.pageX : ev.touches[0].pageX;
            this.stickStartPos.mouseY = typeof ev.pageY !== 'undefined' ? ev.pageY : ev.touches[0].pageY;
            this.stickStartPos.left = this.left;
            this.stickStartPos.right = this.right;
            this.stickStartPos.top = this.top;
            this.stickStartPos.bottom = this.bottom;
            this.currentStick = stick.split('');
            this.stickAxis = null;

            switch (this.currentStick[0]) {
                case 'b':
                    this.stickAxis = 'y';
                    break;
                case 't':
                    this.stickAxis = 'y';
                    break;
            }
            switch (this.currentStick[1]) {
                case 'r':
                    this.stickAxis = this.stickAxis === 'y' ? 'xy' : 'x';
                    break;
                case 'l':
                    this.stickAxis = this.stickAxis === 'y' ? 'xy' : 'x';
                    break;
            }


            this.limits = this.calcResizeLimitation();
        },

        calcResizeLimitation() {
            let minw = this.minWidth ?? 0;
            let minh = this.minHeight ?? 0;
            const aspectFactor = this.aspectFactor;
            const width = this.width;
            const height = this.height;
            const bottom = this.bottom;
            const top = this.top;
            const left = this.left;
            const right = this.right;
            const stickAxis = this.stickAxis;

            const parentLim = this.parentLimitation ? 0 : null;
			
            if (this.aspectRatio) {
                if (minw / minh > aspectFactor) {
                    minh = minw / aspectFactor;
                } else {
                    minw = aspectFactor * minh;
                }
            }

            let limits = {
                minLeft: parentLim,
                maxLeft: left + (width - minw),
                minRight: parentLim,
                maxRight: right + (width - minw),
                minTop: parentLim,
                maxTop: top + (height - minh),
                minBottom: parentLim,
                maxBottom: bottom + (height - minh)
            };
            if (this.aspectRatio) {
                const aspectLimits = {
                    minLeft: left - (Math.min(top, bottom) * aspectFactor) * 2,
                    maxLeft: left + ((((height - minh) / 2) * aspectFactor) * 2),

                    minRight: right - (Math.min(top, bottom) * aspectFactor) * 2,
                    maxRight: right + ((((height - minh) / 2) * aspectFactor) * 2),

                    minTop: top - (Math.min(left, right) / aspectFactor) * 2,
                    maxTop: top + ((((width - minw) / 2) / aspectFactor) * 2),

                    minBottom: bottom - (Math.min(left, right) / aspectFactor) * 2,
                    maxBottom: bottom + ((((width - minw) / 2) / aspectFactor) * 2)
                };

                if (stickAxis === 'x') {
                    limits = {
                        minLeft: Math.max(limits.minLeft, aspectLimits.minLeft),
                        maxLeft: Math.min(limits.maxLeft, aspectLimits.maxLeft),
                        minRight: Math.max(limits.minRight, aspectLimits.minRight),
                        maxRight: Math.min(limits.maxRight, aspectLimits.maxRight)
                    }
                } else if (stickAxis === 'y') {
                    limits = {
                        minTop: Math.max(limits.minTop, aspectLimits.minTop),
                        maxTop: Math.min(limits.maxTop, aspectLimits.maxTop),
                        minBottom: Math.max(limits.minBottom, aspectLimits.minBottom),
                        maxBottom: Math.min(limits.maxBottom, aspectLimits.maxBottom)
                    }
                }
            }


            return limits;
        },

        stickMove(ev) {
            const stickStartPos = this.stickStartPos;
            const pageX = typeof ev.pageX !== 'undefined' ? ev.pageX : ev.touches[0].pageX;
            const pageY = typeof ev.pageY !== 'undefined' ? ev.pageY : ev.touches[0].pageY;

            const delta = {
                x: (stickStartPos.mouseX - pageX) / this.parentScaleX,
                y: (stickStartPos.mouseY - pageY) / this.parentScaleY
            };

            let newTop = stickStartPos.top - delta.y;
            let newBottom = stickStartPos.bottom - delta.y;
            let newLeft = stickStartPos.left - delta.x;
            let newRight = stickStartPos.right - delta.x;

            switch (this.currentStick[0]) {
                case 'b':

                    if (this.snapToGrid) {
                        newBottom = this.parentHeight - Math.round((this.parentHeight - newBottom) / this.gridY) * this.gridY;
                    }

                    this.rawBottom = newBottom;
                	this.setNewBottom(newBottom);
                    break;

                case 't':

                    if (this.snapToGrid) {
                        newTop = Math.round(newTop / this.gridY) * this.gridY;
                    }

                    this.rawTop = newTop;
                	this.setNewTop(newTop);
                    break;
            }

            switch (this.currentStick[1]) {
                case 'r':

                    if (this.snapToGrid) {
                        newRight = this.parentWidth - Math.round((this.parentWidth - newRight) / this.gridX) * this.gridX;
                    }

                    this.rawRight = newRight;
                	this.setNewRight(newRight);
                    break;

                case 'l':

                    if (this.snapToGrid) {
                        newLeft = Math.round(newLeft / this.gridX) * this.gridX;
                    }

                    this.rawLeft = newLeft;
                	this.setNewLeft(newLeft);
                    break;
            }

            this.$emit('resizing', this.rect);
        },

        stickUp() {
            this.stickDrag = false;
            this.stickStartPos = {
                mouseX: 0,
                mouseY: 0,
                x: 0,
                y: 0,
                w: 0,
                h: 0
            };
            this.limits = {
                minLeft: null,
                maxLeft: null,
                minRight: null,
                maxRight: null,
                minTop: null,
                maxTop: null,
                minBottom: null,
                maxBottom: null
            };
            this.rawTop = this.top;
            this.rawBottom = this.bottom;
            this.rawLeft = this.left;
            this.rawRight = this.right;

            this.stickAxis = null;

            this.$emit('resizing', this.rect);
            this.$emit('resizestop', this.rect);
        },

        aspectRatioCorrection() {
          if (!this.aspectRatio) {
                return
            }
			
            const bottom = this.bottom;
            const top = this.top;
            const left = this.left;
            const right = this.right;
            const width = this.width;
            const height = this.height;
            const aspectFactor = this.aspectFactor;
            const currentStick = this.currentStick;
            if (width / height > aspectFactor) {
                let newWidth = aspectFactor * height;

                if (currentStick[1] === 'l') {
                    this.left = left + width - newWidth;
                } else {
                    this.right = right + width - newWidth;
                }
            } else {
                let newHeight = width / aspectFactor;

                if (currentStick[0] === 't') {
                    this.top = top + height - newHeight;
                } else {
                    this.bottom = bottom + height - newHeight;
                }
            }
        },
        setNewLeft(newLeft) {
          this.left = newLeft;
        },
        setNewTop(newTop) {
          this.top = newTop;
    	},
      	setNewRight(newRight) {
          this.right = newRight;
        },
        setNewBottom(newBottom) {
          this.bottom = newBottom;
    	}
    },

    computed: {
        style() {
            return {
                top: this.top + 'px',
                left: this.left + 'px',
                width: this.width + 'px',
                height: this.height + 'px',
                zIndex: this.zIndex
            }
        },

        vdrStick() {
            return (stick) => {
                const stickStyle = {
                    width: `${this.stickSize / this.parentScaleX}px`,
                    height: `${this.stickSize / this.parentScaleY}px`,
                };
                stickStyle[styleMapping.y[stick[0]]] = `${this.stickSize / this.parentScaleX / -2}px`;
                stickStyle[styleMapping.x[stick[1]]] = `${this.stickSize / this.parentScaleX / -2}px`;
                return stickStyle;
            }
        },

        width() {
//             return this.parentWidth - this.left - this.right;
          return this.right - this.left;
        },

        height() {
//             return this.parentHeight - this.top - this.bottom;
          return this.bottom - this.top;
        },

        rect() {
            return {
                left: Math.round(this.left),
                top: Math.round(this.top),
                width: Math.round(this.width),
                height: Math.round(this.height)
            }
        }
    },

    watch: {
        rawLeft(newLeft) {
            const limits = this.limits;
            const stickAxis = this.stickAxis;
            const aspectFactor = this.aspectFactor;
            const aspectRatio = this.aspectRatio;
            const left = this.left;
            const bottom = this.bottom;
            const top = this.top;

            if (limits.minLeft !== null && newLeft < limits.minLeft) {
                newLeft = limits.minLeft;
            } else if (limits.maxLeft !== null && limits.maxLeft < newLeft) {
                newLeft = limits.maxLeft;
            }

            if (aspectRatio && stickAxis === 'x') {
                const delta = left - newLeft;
                this.rawTop = top - (delta / aspectFactor) / 2;
                this.rawBottom = bottom - (delta / aspectFactor) / 2;
            }

            this.left = newLeft;
        },

        rawRight(newRight) {
            const limits = this.limits;
            const stickAxis = this.stickAxis;
            const aspectFactor = this.aspectFactor;
            const aspectRatio = this.aspectRatio;
            const right = this.right;
            const bottom = this.bottom;
            const top = this.top;

            if (limits.minRight !== null && newRight < limits.minRight) {
                newRight = limits.minRight;
            } else if (limits.maxRight !== null && limits.maxRight < newRight) {
                newRight = limits.maxRight;
            }

            if (aspectRatio && stickAxis === 'x') {
                const delta = right - newRight;
                this.rawTop = top - (delta / aspectFactor) / 2;
                this.rawBottom = bottom - (delta / aspectFactor) / 2;
            }

            this.right = newRight;
        },

        rawTop(newTop) {
            const limits = this.limits;
            const stickAxis = this.stickAxis;
            const aspectFactor = this.aspectFactor;
            const aspectRatio = this.aspectRatio;
            const right = this.right;
            const left = this.left;
            const top = this.top;

            if (limits.minTop !== null && newTop < limits.minTop) {
                newTop = limits.minTop;
            } else if (limits.maxTop !== null && limits.maxTop < newTop) {
                newTop = limits.maxTop;
            }

            if (aspectRatio && stickAxis === 'y') {
                const delta = top - newTop;
                this.rawLeft = left - (delta * aspectFactor) / 2;
                this.rawRight = right - (delta * aspectFactor) / 2;
            }

            this.top = newTop;
        },

        rawBottom(newBottom) {
            const limits = this.limits;
            const stickAxis = this.stickAxis;
            const aspectFactor = this.aspectFactor;
            const aspectRatio = this.aspectRatio;
            const right = this.right;
            const left = this.left;
            const bottom = this.bottom;

            if (limits.minBottom !== null && newBottom < limits.minBottom) {
                newBottom = limits.minBottom;
            } else if (limits.maxBottom !== null && limits.maxBottom < newBottom) {
                newBottom = limits.maxBottom;
            }

            if (aspectRatio && stickAxis === 'y') {
                const delta = bottom - newBottom;
                this.rawLeft = left - (delta * aspectFactor) / 2;
                this.rawRight = right - (delta * aspectFactor) / 2;
            }

            this.bottom = newBottom;
        },

        width() {
            this.aspectRatioCorrection();
        },

        height() {
            this.aspectRatioCorrection();
        },

        active(isActive) {
            if (isActive) {
                this.$emit('activated');
            } else {
                this.$emit('deactivated');
            }
        },

        isActive(val) {
            this.active = val;
        },

        z(val) {
            if (val >= 0 || val === 'auto') {
                this.zIndex = val
            }
        },

        aspectRatio(val) {
            if (val) {
                this.aspectFactor = this.width / this.height;
            }
        },

        minw(val) {
            if (val > 0 && val <= this.width) {
                this.minWidth = val
            }
        },

        minh(val) {
            if (val > 0 && val <= this.height) {
                this.minHeight = val
            }
        },

        x() {
            if (this.stickDrag || this.bodyDrag) {
                return
            }
            if (this.parentLimitation) {
                this.limits = this.calcDragLimitation();
            }

            let delta = this.x - this.left;
            this.rawLeft = this.x;
            this.rawRight = this.right - delta;
        },

        y() {
            if (this.stickDrag || this.bodyDrag) {
                return
            }

            if (this.parentLimitation) {
                this.limits = this.calcDragLimitation();
            }

            let delta = this.y - this.top;
            this.rawTop = this.y;
            this.rawBottom = this.bottom - delta;
        },

        w() {
            if (this.stickDrag || this.bodyDrag) {
                return
            }

            this.currentStick = ['m', 'r'];
            this.stickAxis = 'x';

            if (this.parentLimitation) {
                this.limits = this.calcResizeLimitation();
            }

            let delta = this.width - this.w;
            this.rawRight = this.right + delta;
        },

        h() {
            if (this.stickDrag || this.bodyDrag) {
                return
            }

            this.currentStick = ['b', 'm'];
            this.stickAxis = 'y';

            if (this.parentLimitation) {
                this.limits = this.calcResizeLimitation();
            }

            let delta = this.height - this.h;
            this.rawBottom = this.bottom + delta;
        },

        parentW(val) {
            this.right = val - this.width - this.left;
            this.parentWidth = val;

        },

        parentH(val) {
            this.bottom = val - this.height - this.top;
            this.parentHeight = val;

        }
    }
})

Vue.component('slider', {
    template: `
    <carousel :nav="false">
    <div v-for="thumb in backgroundImages" v-bind:key="thumb.id">
      <button
        class="btn-thumbnail"
        :class="{'card-bg-selected': currentBgClass === thumb.cssClass}"
        @click="chooseThumbnail(thumb.cssClass)"
      >
        <img :src="thumb.thumbnail" class="img-fluid card-bg" :alt="thumb.altText" />
        <h5>{{thumb.altText}}</h5>
      </button>
    </div>
  </carousel>
    `,
    props: {
        backgroundImages: Array
    },
    data: function () {
        return {
            currentBgClass: this.backgroundImages[0].cssClass
        };
    },
    methods: {
        chooseThumbnail(selectedClass) {
            this.currentBgClass = selectedClass;
            this.$emit("choose-thumb", selectedClass);
        }
    }

})
const router = new VueRouter({
    mode: 'history',
    routes: [
      ]
 });

var appPreviewYourName = new Vue({
    delimiters: ['${', '}'],
    el: '#app',
    router: router,
    data: function() {
        return {
          headingText: "",
          stainLabel: "",
          etsyUrl: "",
          stepThreeText: "",
          stainChartImage: "",
          clickToChartText: "",
          browser: null,
          middleNameSize: 1,
          firstNameSize: 1,
          isMobile: false,
          showFonts: true,
          scaleMiddle: 3.5,
          scaleFirst: 3.5,
          shortUrl: "",
          isReady: false,
          widthFirst: 250,
          heightFirst: 100,
          topFirst: 100,
          leftFirst: 250,
          widthMiddle: 250,
          heightMiddle: 100,
          topMiddle: 250,
          leftMiddle: 250,
          selectedFont: '',
          selectedColor: '',
          connectDots: false,
          nameOrText: '',
          nameOrLetter: '',
          defaultValue: 'Sample',
          orderingTips: 'Ordering Tips: All names are cut with the capitalization you type in the text field, please be sure to type the name with the exact capitalization (or lowercase) that you desire. Letters such as "j" and "i" contain dots that are not naturally connected to the letters when previewed in our font previewer. However for ease of hanging we will connect the dot to the base of the letter unless you specifically tell us otherwise. You may leave us any order notes after you add the item to your shopping cart.',
          acceptDisclaimer: false,
          proofRequested: false,
          widths: '',
          fontSize: 0,
          currentBgClass: '',
          zoomPreview: 0,
          doesNameContainLowercaseIOrJ() {
            if (this.firstNameText.indexOf('i') !== -1 || this.firstNameText.indexOf('j') !== -1 || this.middleNameText.indexOf('i') !== -1 || this.middleNameText.indexOf('j') !== -1) {
                return 'Yes';
            } else {
                return 'No';
            }
          },
          fontsSelected() {
            if (this.selectedFirstNameFont != '' && this.selectedMiddleNameFont != '') {
              return true;
            }
            return false;
          },
          fontComboOptions: [
            {
              thumbnail: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/round_combo_Delilah_Harper.png",
              cssClass: "delilah-harper",
              id: 8
            },
            {
              thumbnail: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/round_combo_James_Harper.png",
              cssClass: "james-harper",
              id: 15
            },
            {
              thumbnail: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/round_combo_HARPER_JAMES.png",
              cssClass: "harper-james",
              id: 3
            },
            {
              thumbnail: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/round_combo_CASH_JAMES.png",
              cssClass: "cash-james",
              id: 1
            },
            {
              thumbnail: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/round_combo_EVERETT_SAWYER.png",
              cssClass: "everette-sawyer",
              id: 2
            },
            {
              thumbnail: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/round_combo_Reese_James.png",
              cssClass: "reese-james",
              id: 18
            },
            {
              thumbnail: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/round_combo_Benjamin_Flynn.png",
              cssClass: "benjamin-flynn",
              id: 5
            },
            {
              thumbnail: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/round_combo_Cash_Sawyer.png",
              cssClass: "cash-sawyer",
              id: 7
            },
            {
              thumbnail: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/round_combo_Fiona_James.png",
              cssClass: "fiona-james",
              id: 9
            },
            {
              thumbnail: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/round_combo_Harlow_Mae.png",
              cssClass: "harlow-mae",
              id: 12
            },
            {
              thumbnail: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/round_combo_Sunny_James.png",
              cssClass: "sunny-james",
              id: 20
            },
            {
              thumbnail: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/round_combo_Sienna_Mae.png",
              cssClass: "sienna-mae",
              id: 19
            },
            {
              thumbnail: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/round_combo_Theodore_Harper.png",
              cssClass: "theodore-harper",
              id: 22
            },
            {
              thumbnail: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/round_combo_Alex_Theodore.png",
              cssClass: "alex-theodore",
              id: 4
            },
            {
              thumbnail: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/round_combo_Cash_Jack.png",
              cssClass: "cash-jack",
              id: 6
            },
            {
              thumbnail: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/round_combo_Flynn_Oliver.png",
              cssClass: "flynn-oliver",
              id: 11
            },
            {
              thumbnail: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/round_combo_Henry_Austin.png",
              cssClass: "henry-austin",
              id: 14
            },
            {
              thumbnail: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/round_combo_Oliver_Emmie.png",
              cssClass: "oliver-emmie",
              id: 16
            },
            {
              thumbnail: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/round_combo_Reese_Jack.png",
              cssClass: "reese-jack",
              id: 17
            },
    
            {
              thumbnail: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/round_combo_Flynn_Benjamin.jpg",
              cssClass: "flynn-benjamin",
              id: 10
            },
            {
              thumbnail: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/round_combo_Harper_Jack.png",
              cssClass: "harper-jack",
              id: 13
            },
            {
              thumbnail: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/round_combo_Sunny_Liam.png",
              cssClass: "sunny-liam",
              id: 21
            }
          ],
          currentCombo: "harper-james",
          showDrpFirstNameColor: false,
          showDrpMiddleNameColor: false,
          showDrpFirstFont: false,
          showDrpMiddleFont: false,
          showDrpStain: false,
          basePrice: 65,
          emptyFirstNameText: "HARPER",
          emptyMiddleNameText: "james",
          inputAgree: null,
          inputProof: null,
          inputPositioning: null,
          displayFirstNameText: "First Name",
          firstNameText: "",
          middleNameText: "",
          valueLimit: 10,
          selectedFirstNameFont: "",
          selectedMiddleNameFont: "",
          selectedFirstNameColor: "#c19067",
          selectedMiddleNameColor: "#c19067",
          colorChosenFirstName: false,
          colorChosenMiddleName: false,
    	  promoInformation: 0,
          chosenBaseStain: false,
          selectedBase: {},
          baseColorStains: [],
          colorOptions: [
            {
              name: "Unpainted - Baltic Birch Wood Grain",
              value: "#c19067",
              fontId: "block_6",
              addOn: false
            },
            {
              name: "Peach",
              value: "#fac6ae",
              fontId: "block_7",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Blush",
              value: "#f8dad8",
              fontId: "block_8",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Pink",
              value: "#fac7cc",
              fontId: "block_9",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Peony",
              value: "#eca9d4",
              fontId: "block_10",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Bright Pink",
              value: "#ea7d9d",
              fontId: "block_11",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Coral",
              value: "#ffa195",
              fontId: "block_12",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Red",
              value: "#cb2d2c",
              fontId: "block_13",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Orange",
              value: "#f9ad59",
              fontId: "block_14",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Yellow",
              value: "#f4de66",
              fontId: "block_15",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Yellow Green",
              value: "#69b55a",
              fontId: "block_16",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Green",
              value: "#278b4d",
              fontId: "block_17",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Mint",
              value: "#c1e1d6",
              fontId: "block_18",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Turquoise",
              value: "#50c3b2",
              fontId: "block_19",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Teal",
              value: "#00927b",
              fontId: "block_20",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Light Blue",
              value: "#cbe9f4",
              fontId: "block_21",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Blue",
              value: "#154b87",
              fontId: "block_22",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Navy",
              value: "#2c3764",
              fontId: "block_23",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Lilac",
              value: "#c481b6",
              fontId: "block_24",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Violet",
              value: "#ccb8d1",
              fontId: "block_25",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Purple",
              value: "#957ab1",
              fontId: "block_26",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Light Gray",
              value: "#bbc2c8",
              fontId: "block_27",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Dark Gray",
              value: "#64686b",
              fontId: "block_28",
              addOn: true,
              collection: "classic"
            },
            {
              name: "White",
              value: "#f2f3ee",
              fontId: "block_29",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Black",
              value: "#343436",
              fontId: "block_30",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Ivory",
              value: "#f9f2df",
              fontId: "block_31",
              addOn: true,
              collection: "classic"
            },
            {
              name: "Silver",
              value: "#dee2e3",
              fontId: "block_32",
              addOn: true,
              collection: "glitter"
            },
            {
              name: "Gold",
              value: "#c2a973",
              fontId: "block_33",
              addOn: true,
              collection: "glitter"
            },
            {
              name: "Rose Gold",
              value: "#c08f80",
              fontId: "block_34",
              addOn: true,
              collection: "glitter"
            },
            {
              name: "Silver Glitter",
              value: "#dee2e3aa",
              fontId: "block_35",
              isGlitter: true,
              addOn: true,
              collection: "glitter"
            },
            {
              name: "Gold Glitter",
              value: "#c2a973aa",
              fontId: "block_36",
              isGlitter: true,
              addOn: true,
              collection: "glitter"
            },
            {
              name: "Rose Gold Glitter",
              value: "#c08f80aa",
              fontId: "block_37",
              isGlitter: true,
              addOn: true,
              collection: "glitter"
            },
            {
              name: "Cognac",
              value: "#784534",
              fontId: "block_39",
              isGlitter: false,
              addOn: true,
              collection: "boho"
            },
            {
              name: "Terra Cotta",
              value: "#B16C59",
              fontId: "block_40",
              isGlitter: false,
              addOn: true,
              collection: "boho"
            },
            {
              name: "Rust",
              value: "#AF664B",
              fontId: "block_41",
              isGlitter: false,
              addOn: true,
              collection: "boho"
            },
            {
              name: "Clay",
              value: "#E5B195",
              fontId: "block_42",
              isGlitter: false,
              addOn: true,
              collection: "boho"
            },
            {
              name: "Mustard",
              value: "#BA7F4B",
              fontId: "block_43",
              isGlitter: false,
              addOn: true,
              collection: "boho"
            },
            {
              name: "Marigold",
              value: "#F7D394",
              fontId: "block_44",
              isGlitter: false,
              addOn: true,
              collection: "boho"
            },
            {
              name: "Olive",
              value: "#A88952",
              fontId: "block_45",
              isGlitter: false,
              addOn: true,
              collection: "boho"
            },
            {
              name: "Hunter Green",
              value: "#323E37",
              fontId: "block_46",
              isGlitter: false,
              addOn: true,
              collection: "boho"
            },
            {
              name: "Moss",
              value: "#8B8879",
              fontId: "block_47",
              isGlitter: false,
              addOn: true,
              collection: "boho"
            },
            {
              name: "Silver Sage",
              value: "#DEE3DB",
              fontId: "block_48",
              isGlitter: false,
              addOn: true,
              collection: "boho"
            },
            {
              name: "Sand",
              value: "#E8Dcc6",
              fontId: "block_49",
              isGlitter: false,
              addOn: true,
              collection: "boho"
            },
            {
              name: "Apricot",
              value: "#FCEADB",
              fontId: "block_50",
              isGlitter: false,
              addOn: true,
              collection: "boho"
            }
          ],
          fontsScript: [
            { font: "AIDEN", fontId: "script_1", defaultSize: 1 },
            { font: "ALEXANDRA", fontId: "script_2", defaultSize: 0.75 },
            { font: "ARIANNA", fontId: "script_3", defaultSize: 0.75 },
            { font: "AUBREE", fontId: "script_4", defaultSize: 1 },
            { font: "BELLA", fontId: "script_5", defaultSize: 1.5 },
            { font: "BENJAMIN", fontId: "script_5_5", defaultSize: 1.5 },
            { font: "BRODY", fontId: "script_6", defaultSize: 1.5 },
            { font: "CHARLOTTE", fontId: "script_7", defaultSize: 1.5 },
            { font: "DELILAH", fontId: "script_8", defaultSize: 0.75 },
            { font: "EMMA", fontId: "script_9", defaultSize: 0.65 },
            { font: "HARLOW", fontId: "script_10", defaultSize: 1.5 },
            { font: "HENRY", fontId: "script_11", defaultSize: 1.5 },
            { font: "ISABELLA", fontId: "script_12", defaultSize: 0.7 },
            { font: "JACK", fontId: "script_13", defaultSize: 1.5 },
            { font: "JAMES", fontId: "script_14", defaultSize: 0.85 },
            { font: "JETT", fontId: "script_15", defaultSize: 1.5 },
            { font: "LIAM", fontId: "script_16", defaultSize: 1.25 },
            { font: "LUCAS", fontId: "script_17", defaultSize: 0.5 },
            { font: "MICHAEL", fontId: "script_18", defaultSize: 0.75 },
            { font: "MILES", fontId: "script_19", defaultSize: 0.75 },
            { font: "OLIVER", fontId: "script_20", defaultSize: 1.25 },
            { font: "OLIVIA", fontId: "script_21", defaultSize: 0.85 },
            { font: "SAWYER", fontId: "script_22", defaultSize: 1.55 },
            { font: "SEREPHINA", fontId: "script_23", defaultSize: 1.5 },
            { font: "SIENNA", fontId: "script_24", defaultSize: 0.25 },
            { font: "SLOANE", fontId: "script_25", defaultSize: 0.75 },
            { font: "SOPHIA", fontId: "script_26", defaultSize: 0.75 },
            { font: "THEODORE", fontId: "script_27", defaultSize: 0.75 },
            { font: "THOMAS", fontId: "script_28", defaultSize: 0.5 },
            { font: "WILLIAM", fontId: "script_29", defaultSize: 0.7 }
          ],
          fontsBlock: [
            { font: "ALEX", fontId: "block_28", defaultSize: 0.75 },
            { font: "AUSTIN", fontId: "block_39", defaultSize: 0.9 },
            { font: "AXEL", fontId: "block_40", defaultSize: 0.45 },
            { font: "BEAU", fontId: "block_41", defaultSize: 1 },
            { font: "BROOKS", fontId: "block_42", defaultSize: 0.7 },
            { font: "CASH", fontId: "block_43", defaultSize: 1 },
            { font: "CHLOE", fontId: "block_44", defaultSize: 1 },
            {
              font: "CLEMENTINE",
              fontId: "block_45",
              defaultSize: 2.55,
              topMarginAdjust: "-40px"
            },
            {
              font: "CREW",
              fontId: "block_46",
              defaultSize: 1.75,
              topMarginAdjust: "-40px"
            },
            {
              font: "DUKE",
              fontId: "block_47",
              defaultSize: 2.25,
              topMarginAdjust: "-40px"
            },
            { font: "EMMIE", fontId: "block_48", defaultSize: 1.55 },
            { font: "ETHAN", fontId: "block_49", defaultSize: 0.6 },
            { font: "EVERETTE", fontId: "block_32" },
            { font: "FIONA", fontId: "block_50", defaultSize: 1.22 },
            { font: "FLYNN", fontId: "block_50_5", defaultSize: 1.22 },
            {
              font: "GEORGIA",
              fontId: "block_51",
              defaultSize: 2,
              topMarginAdjust: "-40px"
            },
            { font: "HARPER", fontId: "block_52", defaultSize: 1.25 },
            { font: "HUDSON", fontId: "block_53", defaultSize: 0.9 },
            { font: "JAXON", fontId: "block_54", defaultSize: 1.2 },
            { font: "LAYLA", fontId: "block_55", defaultSize: 1.05 },
            {
              font: "MAE",
              fontId: "block_56",
              defaultSize: 2.2,
              topMarginAdjust: "-40px"
            },
            { font: "MASON", fontId: "block_57", defaultSize: 1.35 },
            { font: "MAVERICK", fontId: "block_58", defaultSize: 0.95 },
            { font: "MAX", fontId: "block_59", defaultSize: 0.85 },
            { font: "QUINN", fontId: "block_60", defaultSize: 0.9 },
            { font: "REESE", fontId: "block_61", defaultSize: 1.45 },
            { font: "RYDER", fontId: "block_62", defaultSize: 1.15 },
            { font: "SKIPPER", fontId: "block_63", defaultSize: 1.3 },
            { font: "SUNNY", fontId: "block_64", defaultSize: 0.83 },
            { font: "TRISTAN", fontId: "block_65", defaultSize: 0.73 },
            { font: "VIOLET", fontId: "block_66", defaultSize: 1.25 },
            { font: "WYATT", fontId: "block_67", defaultSize: 1.2 }
          ]
        };
      },
      computed: {
        baseStainName() {
          if (!this.chosenBaseStain) {
            return this.stepThreeText;
          } else {
            return `${this.stainLabel}: ${this.selectedBase.name}`;
          }
        },
        dropFirstNameFont() {
          if (!this.selectedFirstNameFont) {
            return "First Name Font";
          } else {
            return `First: ${this.selectedFirstNameFont.toLowerCase()}`;
          }
        },
        dropMiddleNameFont() {
          if (!this.selectedMiddleNameFont) {
            return "Middle Name Font";
          } else {
            return `Middle: ${this.selectedMiddleNameFont.toLowerCase()}`;
          }
        },
        lettersWithDots() {
          const i = this.firstNameText.indexOf('i') !== -1 ? this.firstNameText.indexOf('i') !== -1 : this.middleNameText.indexOf('i') !== -1;
            const j = this.firstNameText.indexOf('j') !== -1 ? this.firstNameText.indexOf('j') !== -1 : this.middleNameText.indexOf('j') !== -1;

            if (i && j) {
                return 'i and j';
            }
            else if (i) {
                return 'i';
            }
            return 'j';
        },
        order_total() {
          const priceWithLetters =
            this.getPriceWithLetters(this.firstNameText.length + this.middleNameText.length); 
            //this.basePrice +
            //this.firstNameText.length * 10 +
            //this.middleNameText.length * 10;
          return priceWithLetters;
        },
        order_total_after_promo() {
          const promoInformation =  this.promoInformation;
          if (promoInformation == 0) {
            return '';
          }
          const priceWithLetters =
                this.getPriceWithLetters(this.firstNameText.length + this.middleNameText.length) * (1 - (promoInformation/100)); 
            //this.basePrice +
            //this.firstNameText.length * 10 +
            //this.middleNameText.length * 10;
          return '$'+priceWithLetters;
        },
        order_total_style() {
          if (this.promoInformation > 0) {
            return 'line-through';
          }
          
          return 'unset';
        },
		promo_information() {
          if (this.promoInformation > 0) {
	          return '('+this.promoInformation+ '% PROMOTION)';
          } else {
            return '';
          }
        },
        amount_of_letters() {
          return this.firstNameText.length + this.middleNameText.length;
        },
        colors_boho() {
          return this.colorOptions
            .filter(opt => opt.addOn === true)
            .filter(color => color.collection === "boho");
        },
        colors_classic() {
          return this.colorOptions
            .filter(opt => opt.addOn === true)
            .filter(color => color.collection === "classic");
        },
        colors_glitter() {
          return this.colorOptions
            .filter(opt => opt.addOn === true)
            .filter(color => color.collection === "glitter");
        },
        styleFirstName() {
          return {
            fontFamily: this.selectedFirstNameFont,
            color: this.selectedFirstNameColor
            
          };
        },
        styleMiddleName() {
          return {};
        }
      },
      mounted: async function() {
        this.selectedBase = this.baseColorStains[0];
        this.selectedFirstNameFont = "harper";
        this.selectedMiddleNameFont = "james";
        this.loadParameters();
        this.isReady = true;
        this.onResize();
        window.addEventListener("resize", this.onResize, { passive: true });
        if (document.body.classList.contains("safari")) {
          this.browser = "safari";
        } else {
          this.browser = "not-safari";
        }
      },
      methods: {
        closeApp(){
            return MicroModal.close("modal-options");
        },
        setPromoInformation() {
            this.promoInformation = document.getElementById('promo_information') ? document.getElementById('promo_information').value : 0;
            console.log(this.promoInformation);
          },
            
        getPriceWithLetters(letterLength) {
          	this.setPromoInformation();
            var pricingArray = [];
            pricingArray[2] = 85;
            pricingArray[3] = 95;
            pricingArray[4] = 100;
            pricingArray[5] = 110;
            pricingArray[6] = 120;
            pricingArray[7] = 130;
            pricingArray[8] = 140;
            pricingArray[9] = 150;
            pricingArray[10] = 155;
            pricingArray[11] = 168;
            pricingArray[12] = 175;
            pricingArray[13] = 185;
            pricingArray[14] = 195;
            pricingArray[15] = 205;
            pricingArray[16] = 215;
            pricingArray[17] = 225;
            pricingArray[18] = 235;
            pricingArray[19] = 240;
            pricingArray[20] = 250;
            pricingArray[21] = 255;
            pricingArray[22] = 265;
            pricingArray[23] = 270;
            pricingArray[24] = 280;
            pricingArray[25] = 285;
          
          return pricingArray[letterLength];
        },
        recalibrate() {
          this.showFonts = false;
          this.showFonts = true;
          this.$nextTick(function() {
            this.resizeFirst({
              width: this.widthFirst,
              height: this.heightFirst,
              top: this.topFirst,
              left: this.leftFirst
            });
            this.resizeMiddle({
              width: this.widthMiddle,
              height: this.heightMiddle,
              top: this.topMiddle,
              left: this.leftMiddle
            });
          });
        },
        async updateRouteQuery(queryName, queryValue) {
          // Must make sure the current route does not already have this query param
          const query = Object.assign({}, this.$route.query);
    
          if (query[queryName] !== queryValue) {
            query[queryName] = queryValue;
            return await this.$router
              .replace({
                ...this.$router.currentRoute,
                query
              })
              .catch(() => {});
          }
        },
        loadParameters() {
          const params = this.$route.query;
          if (params.firstName) {
            this.firstNameText = params.firstName;
            this.inputFirstName = this.firstNameText;
            MicroModal.show('modal-options');
          }
          if (params.firstNameColor) {
            const foundColor = this.colorOptions.find(opt => {
              return opt.name.toLowerCase() == params.firstNameColor.toLowerCase();
            });
            this.selectedFirstNameColor = foundColor.value;
            this.colorChosenFirstName = true;
          }
          if (params.firstNameFont) {
            const foundFont = this.getFont(params.firstNameFont);
            this.selectedFirstNameFont = foundFont.font;
          }
          if (params.middleName) {
            this.middleNameText = params.middleName;
            this.inputMiddleName = this.middleNameText;
          }
          if (params.middleNameColor) {
            const foundColor = this.colorOptions.find(opt => {
              return opt.name.toLowerCase() == params.middleNameColor.toLowerCase();
            });
            this.selectedMiddleNameColor = foundColor.value;
            this.colorChosenMiddleName = true;
          }
          if (params.middleNameFont) {
            const foundFont = this.getFont(params.middleNameFont);
            this.selectedMiddleNameFont = foundFont.font;
          }
          if (params.proof) {
            this.inputProof = params.proof;
          }
          if (params.positioning) {
            this.inputPositioning = params.positioning;
          }
          if (params.agree) {
            this.inputAgree = params.agree;
          }
          if (params.baseStain) {
            const foundBase = this.baseColorStains.find(opt => {
              return opt.baseStainId == parseInt(params.baseStain, 10);
            });
            this.selectedBase = foundBase;
            this.chosenBaseStain = true;
          }
          if (params.widthFirst) {
            this.widthFirst = parseInt(params.widthFirst);
          }
          if (params.heightFirst) {
            this.heightFirst = parseInt(params.heightFirst);
          }
          if (params.topFirst) {
            this.topFirst = parseInt(params.topFirst);
          }
          if (params.leftFirst) {
            this.leftFirst = parseInt(params.leftFirst);
          }
          if (params.widthMiddle) {
            this.widthMiddle = parseInt(params.widthMiddle);
          }
          if (params.heightMiddle) {
            this.heightMiddle = parseInt(params.heightMiddle);
          }
          if (params.topMiddle) {
            this.topMiddle = parseInt(params.topMiddle);
          }
          if (params.leftMiddle) {
            this.leftMiddle = parseInt(params.leftMiddle);
          }
          if (params.scaleMiddle) {
            this.scaleMiddle = parseFloat(params.scaleMiddle);
          }
          if (params.scaleFirst) {
            this.scaleFirst = parseFloat(params.scaleFirst);
          }
        },
        showDropDown(name) {
          if (name == "firstColor") {
            this.showDrpFirstNameColor = !this.showDrpFirstNameColor;
          } else if (name == "middleColor") {
            this.showDrpMiddleNameColor = !this.showDrpMiddleNameColor;
          } else if (name == "stain") {
            this.showDrpStain = !this.showDrpStain;
          } else if (name == "firstFont") {
            this.showDrpFirstFont = !this.showDrpFirstFont;
          } else if (name == "middleFont") {
            this.showDrpMiddleFont = !this.showDrpMiddleFont;
          }
        },
          setBeginningParams() {

          },
          async dragFirst(newRect) {
            await this.updateRouteQuery("topFirst", newRect.top);
            await this.updateRouteQuery("leftFirst", newRect.left);
          },
          
        async resizeFirst(newRect) {
          this.widthFirst = newRect.width;
          this.heightFirst = newRect.height;
          this.topFirst = newRect.top;
          this.leftFirst = newRect.left;
          await this.updateRouteQuery("widthFirst", this.widthFirst);
          await this.updateRouteQuery("heightFirst", this.heightFirst);
          await this.updateRouteQuery("topFirst", this.topFirst);
          await this.updateRouteQuery("leftFirst", this.leftFirst);
          const previewFirst = this.$refs.fitty_first;
		  
          if (previewFirst.clientHeight > 0 && previewFirst.clientWidth > 0) { 
            this.scaleFirst = Math.min(
              this.widthFirst / previewFirst.clientWidth,
              this.heightFirst / previewFirst.clientHeight
            );

            await this.updateRouteQuery("scaleFirst", this.scaleFirst);
          }

          previewFirst.style.transform = "translate(-50%, -50%) " + "scale(" + this.scaleFirst + ")";
        },
        async oldResizeFirst(newRect) {
          console.log(newRect);
          this.widthFirst = newRect.width;
          this.heightFirst = newRect.height;
          this.topFirst = newRect.top;
          this.leftFirst = newRect.left;
          await this.updateRouteQuery("widthFirst", this.widthFirst);
          await this.updateRouteQuery("heightFirst", this.heightFirst);
          await this.updateRouteQuery("topFirst", this.topFirst);
          await this.updateRouteQuery("leftFirst", this.leftFirst);
          const previewFirst = this.$refs.fitty_first;
          console.log('previewFirst.cientWidth',previewFirst.clientWidth);
          console.log('previewFirst.cientHeight',previewFirst.clientHeight);
          console.log('this.widthFirst',this.widthFirst);
          console.log('this.heightFirst',this.heightFirst);
          this.scaleFirst = Math.min(
            this.widthFirst / previewFirst.clientWidth,
            this.heightFirst / previewFirst.clientHeight
          );
          await this.updateRouteQuery("scaleFirst", this.scaleFirst);
          previewFirst.style.width = this.w+'px';
          console.log('previewFirst:',previewFirst.style.width);
          console.log('this.w:',this.w);
          console.log('scaleFirst:',this.scaleFirst);
          previewFirst.style.height = this.h+'px';
          previewFirst.style.top = this.y+'px';
          previewFirst.style.left = this.x+'px';
          previewFirst.style.transform =
            "translate(-50%, -50%) " + "scale(" + this.scaleFirst + ")";
        },
          async dragMiddle(newRect) {
            const previewMiddle = this.$refs.fitty_middle;
            await this.updateRouteQuery("topMiddle", newRect.top);
            await this.updateRouteQuery("leftMiddle", newRect.left);
          },
        async resizeMiddle(newRect) {
		  this.widthMiddle = newRect.width;
          this.heightMiddle = newRect.height;
          this.topMiddle = newRect.top;
          this.leftMiddle = newRect.left;
          await this.updateRouteQuery("widthMiddle", this.widthMiddle);
          await this.updateRouteQuery("heightMiddle", this.heightMiddle);
          await this.updateRouteQuery("topMiddle", this.topMiddle);
          await this.updateRouteQuery("leftMiddle", this.leftMiddle);
          const previewMiddle = this.$refs.fitty_middle;
		  
          if (previewMiddle.clientHeight > 0 && previewMiddle.clientWidth > 0) { 
            this.scaleMiddle = Math.min(
              this.widthMiddle / previewMiddle.clientWidth,
              this.heightMiddle / previewMiddle.clientHeight
            );

            await this.updateRouteQuery("scaleMiddle", this.scaleMiddle);
          }

          previewMiddle.style.transform = "translate(-50%, -50%) " + "scale(" + this.scaleMiddle + ")";
        },
        async oldResizeMiddle(newRect) {
          this.widthMiddle = newRect.width;
          this.heightMiddle = newRect.height;
          this.topMiddle = newRect.top;
          this.leftMiddle = newRect.left;
          await this.updateRouteQuery("widthMiddle", this.widthMiddle);
          await this.updateRouteQuery("heightMiddle", this.heightMiddle);
          await this.updateRouteQuery("topMiddle", this.topMiddle);
          await this.updateRouteQuery("leftMiddle", this.leftMiddle);
          const previewMiddle = this.$refs.fitty_middle;
          this.scaleMiddle = Math.min(
            this.widthMiddle / previewMiddle.clientWidth,
            this.heightMiddle / previewMiddle.clientHeight
          );
          await this.updateRouteQuery("scaleMiddle", this.scaleMiddle);
          previewMiddle.style.transform =
            "translate(-50%, -50%) " + "scale(" + this.scaleMiddle + ")";
        },
        hideDrps() {
          console.log('hide dropdowns');
          this.showDrpFirstNameColor = false;
          this.showDrpMiddleNameColor = false;
          this.showDrpStain = false;
          this.showDrpFirstFont = false;
          this.showDrpMiddleFont = false;
        },
        calcFontSize(size) {
          return (parseInt(size, 10) * 34.21 + 36).toFixed(2);
        },
        chooseFonts() {
          this.formView = "font";
        },
        oldOnCopy: function(e) {
          alert("You just copied: " + e.text);
        },
        onCopy() {
          var copyText = document.getElementById("shortUrl");
          /* Select the text field */
          copyText.select();
          copyText.setSelectionRange(0, 99999); /* For mobile devices */

          /* Copy the text inside the text field */
          document.execCommand("copy");

        },
        onError: function(e) {
          console.error("Failed to copy text ", e);
        },
        getColorOption(value) {
          const option = this.colorOptions.find(opt => opt.value === value);
          if (option.addOn === true) {
            return `Painted ${option.name}`;
          }
          return option.name;
        },
        showColor(name) {
          if (name == "first") {
            if (!this.colorChosenFirstName) {
              return "Select First Name Color";
            }
            return `First: ${this.getColorOption(this.selectedFirstNameColor)}`;
          }
          if (name == "middle") {
            if (!this.colorChosenMiddleName) {
              return "Select Middle Name Color";
            }
            return `Middle: ${this.getColorOption(this.selectedMiddleNameColor)}`;
          }
        },
        closeAlert(whichModal) {
          // this.$nextTick(function() {
          MicroModal.close(`modal-${whichModal}`);
          // });
        },
        openPaintChart() {
          return MicroModal.show("modal-paintChart");
        },
        openStainChart() {
          return MicroModal.show("modal-stainChart");
        },
        onChangeProof(event) {
          const optionText = event.target.value;
          this.updateRouteQuery("proof", optionText);
        },
        onChangePositioning(event) {
          const optionText = event.target.value;
          this.updateRouteQuery("positioning", optionText);
        },
        onChangeAcknowledgement(event) {
          const optionText = event.target.value;
          this.updateRouteQuery("agree", optionText);
        },
        enteredMiddleName() {
          this.updateRouteQuery("middleName", this.middleNameText);
        },
        changeMiddleNameColor(color) {
          this.selectedMiddleNameColor = color.value;
          this.updateRouteQuery("middleNameColor", color.name);
          this.colorChosenMiddleName = true;
          this.hideDrps();
        },
        async selectMiddleNameFont(selected) {
          this.selectedMiddleNameFont = selected.font.toLowerCase();
          this.middleNameSize = selected.defaultSize;
          await this.updateRouteQuery(
            "middleNameFont",
            selected.font.toLowerCase()
          );
          this.hideDrps();
          if (this.doesNameContainLowercaseIOrJ() === 'Yes') {
            this.promptConnectDots = true;
          }
        },
        enteredFirstName(val) {
          this.updateRouteQuery("firstName", this.firstNameText);
        },
        changeFirstNameColor(color) {
          this.selectedFirstNameColor = color.value;
          this.updateRouteQuery("firstNameColor", color.name);
          this.colorChosenFirstName = true;
          this.hideDrps();
        },
        async selectFirstNameFont(selected) {
          this.selectedFirstNameFont = selected.font.toLowerCase();
          this.firstNameSize = selected.defaultSize;
          await this.updateRouteQuery("firstNameFont", selected.font.toLowerCase());
          this.hideDrps();
          if (this.doesNameContainLowercaseIOrJ() === 'Yes') {
            this.promptConnectDots = true;
          }
        },
        selectBaseColor(selected, type) {
          this.selectedBase = selected;
          this.chosenBaseStain = true;
          this.updateRouteQuery("baseStain", selected.baseStainId);
          this.hideDrps();
        },
        getFont(fontName) {
          const foundBlockFont = this.fontsBlock.find(opt => {
            return opt.font.toLowerCase() == fontName;
          });
          if (foundBlockFont) {
            return foundBlockFont;
          } else {
            const foundScriptFont = this.fontsScript.find(opt => {
              return opt.font.toLowerCase() == fontName;
            });
            if (foundScriptFont) {
              return foundScriptFont;
            }
            throw new Error(`font missing: ${fontName}`);
          }
        },
        async fontCombo(combo) {
          const arr = combo.split("-");
          this.selectedFirstNameFont = arr[0];
          this.selectedMiddleNameFont = arr[1];
          await this.updateRouteQuery("firstNameFont", this.selectedFirstNameFont);
          await this.updateRouteQuery(
            "middleNameFont",
            this.selectedMiddleNameFont
          );
        },
        onResize() {
          this.isMobile = window.innerWidth < 600;
        },
        async addToCart() {
          if (!this.firstNameText || !this.middleNameText) {
            return MicroModal.show("modal-missingText");
          }
          if (!this.acceptDisclaimer) {
            return MicroModal.show("modal-missingDisclaimer");
          }
          if (!this.proofRequested) {
            return MicroModal.show("modal-missingProof");
          }
    
//           const payload = {
//             destination: `https://seemyfont.netlify.app/round${window.location.search}`,
//             domain: { fullName: "click.seemyfont.com" }
//           };
//           const requestHeaders = {
//             "Content-Type": "application/json",
//             apikey: "b821c22ee1cb4084a5c81f3f564dfeee",
//             workspace: "f76a473e903c48e38b1d5af7634b6026"
//           };
//           const result = await axios({
//             data: payload,
//             method: "POST",
//             headers: requestHeaders,
//             url: "https://api.rebrandly.com/v1/links",
//             baseURL: ""
//           });
//           this.shortUrl = result.data.shortUrl;
//           return MicroModal.show("modal-selectInfo");
          
          this.addToShopifyCart();
        },
		addToShopifyCart() {
            if (!this.acceptDisclaimer) {
                MicroModal.show('modal-missingDisclaimer'); // [1]
                return;
            }
            if (!this.firstNameText || this.MiddleNameText) {
                this.clickedAddToCartWithoutText = true;
                MicroModal.show('modal-missingText'); // [1]
                return;
            }
            
            if (!this.proofRequested) {
                MicroModal.show('modal-missingProof'); // [1]
                return;
            }
          const payload = {
            destination: `https://www.adorenstudio.com/products/shiplap-round-name-sign${window.location.search}`,
            domain: { fullName: "preview.adorenstudio.com" }
          };
          const requestHeaders = {
            "Content-Type": "application/json",
            apikey: "b821c22ee1cb4084a5c81f3f564dfeee",
            workspace: "f76a473e903c48e38b1d5af7634b6026"
          };
          
          let cart_data  = {
            variantId: this.getShopifyVariantId(),
            baseStainName: this.selectedBase.name,
            firstNameText: this.firstNameText,
            selectedFirstNameFont: this.selectedFirstNameFont,
            selectedFirstNameColor: this.getColorOption(this.selectedFirstNameColor),
            middleNameText: this.middleNameText,
            selectedMiddleNameFont: this.selectedMiddleNameFont,
            selectedMiddleNameColor: this.getColorOption(this.selectedMiddleNameColor),
            inputPositioning: this.inputPositioning,
            acceptDisclaimer: this.acceptDisclaimer,
            proofRequested: this.proofRequested
          };
          
          axios({
            data: payload,
            method: "POST",
            headers: requestHeaders,
            url: "https://api.rebrandly.com/v1/links",
            baseURL: ""
          }).then(function (result) {
            
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data:
              {
                quantity: 1,
                id: cart_data.variantId,
                properties: {
                  'First Name Text': cart_data.firstNameText,
                  'First Name Font': cart_data.selectedFirstNameFont,
                  'First Name Color': cart_data.selectedFirstNameColor,
                  'Middle Name Text': cart_data.middleNameText,
                  'Middle Name Font': cart_data.selectedMiddleNameFont,
                  'Middle Name Color': cart_data.selectedMiddleNameColor,
                  'Positioning': cart_data.inputPositioning,
                  'Base Stain': cart_data.baseStainName,
                  'I have read and understand the disclaimer': cart_data.acceptDisclaimer,
                  'Proof Requested': cart_data.proofRequested,
                  'Preview URL': result.data.shortUrl
                }
              },
              error: function (jqXHR, status) {
                console.log('all done');
                MicroModal.close('modal-options');
                console.log(status);
                window.location.href = '/cart';
              },
              success: function (success) {
                console.log('success', success);
                // error handler

              }

            });
            
          });
//           this.shortUrl = result.data.shortUrl;
          
          //            console.log(this);
            //           debugger;
            // 6138040025267 is the productId
          
          
          
            
        },
          getShopifyVariantId() {
    const numLetters = this.firstNameText.length + this.middleNameText.length;
    var id = 0;
    switch (numLetters) {
      case 2:
        // https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707534749875
        id = '40707534749875';
        break;
      case 3:
        //https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707534782643
        id = '40707534782643';
        break;
      case 4:
        //https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707534815411
        id = '40707534815411';
        break;
      case 5:
        //https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707534848179
        id = '40707534848179';
        break;
      case 6:
        //https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707534880947
        id = '40707534880947';
        break;
      case 7:
        //https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707534913715
        id = '40707534913715';
        break;
      case 8:
        //https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707534946483
        id = '40707534946483';
        break;
      case 9:
        //https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707534979251
        id = '40707534979251';
        break;
      case 10:
        //https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707535012019
        id = '40707535012019';
        break;
      case 11:
        //https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707535044787
        id = '40707535044787';
        break;
      case 12:
        //https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707535077555
        id = '40707535077555';
        break;
      case 13:
        //https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707535110323
        id = '40707535110323';
        break;
      case 14:
        //https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707535143091
        id = '40707535143091';
        break;
      case 15:
        //https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707535175859
        id = '40707535175859';
        break;
      case 16:
        //https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707535208627
        id = '40707535208627';
        break;
      case 17:
        //https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707535241395
        id = '40707535241395';
        break;
      case 18:
        //https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707535274163
        id = '40707535274163';
        break;
      case 19:
        //https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707535306931
        id = '40707535306931';
        break;
      case 20:
        //https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707535339699
        id = '40707535339699';
        break;
      case 21:
        //https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707535372467
        id = '40707535372467';
        break;
      case 22:
        //https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707535405235
        id = '40707535405235';
        break;
      case 23:
        //https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707535438003
        id = '40707535438003';
        break;
      case 24:
        //https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707535470771
        id = '40707535470771';
        break;
      case 25:
        //https://adorenstudio.myshopify.com/admin/products/6936360222899/variants/40707535503539
        id = '40707535503539';
        break;
              
    }
            
            return id;
          },
      },
      created() {
        if (!localStorage.signType) {
            console.error('Missing the signType');
        }
        this.setPromoInformation();
        switch (localStorage.signType) {
            case 'round-shiplap':
              this.headingText = "Shiplap Round Name Sign Designer";
              this.stainLabel = "Shiplap Color";
              this.etsyUrl = "https = /www.etsy.com/listing/882650743";
              this.stepThreeText = "Select Shiplap Color";
              this.stainChartImage = "/images/stainChart.jpg";
              this.clickToChartText = "Click to See Shiplap Color Chart";
              this.baseColorStains = [
                {
                  name: "White",
                  baseStainId: 2,
                  url: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/White_Shiplap_2.png",
                  thumbUrl: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/White_Shiplap_2.png"
                },
                {
                  name: "Black",
                  baseStainId: 0,
//                   url: "https://seemyfont.netlify.app/images/round/Natural_Unfinished.png",
//                   thumbUrl: "https://seemyfont.netlify.app/images/round/thumb_Natural_Unfinished.png"
                  url: '//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/Black_Shiplap.png',
                  thumbUrl: '//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/Black_Shiplap.png'
                },
                {
                  name: "Blush",
                  baseStainId: 3,
                  url: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/Blush_Shiplap.png",
                  thumbUrl: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/Blush_Shiplap.png"
                },
                {
                  name: "Dark Gray",
                  baseStainId: 9,
                  url: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/Dark_Gray_Shiplap.png",
                  thumbUrl: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/Dark_Gray_Shiplap.png"
                },
                {
                  name: "Hunter Green",
                  baseStainId: 8,
                  url: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/HunterGreenShiplap.png",
                  thumbUrl: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/HunterGreenShiplap.png"
                },
                {
                  name: "Light Gray",
                  baseStainId: 16,
                  url: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/LightGray_Shiplap.png",
                  thumbUrl: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/LightGray_Shiplap.png"
                },
                {
                  name: "Moss",
                  baseStainId: 10,
                  url: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/MossShiplap.png",
                  thumbUrl: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/MossShiplap.png"
                },
                {
                  name: "Natural",
                  baseStainId: 5,
                  url: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/Natural_Shiplap.png",
                  thumbUrl: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/Natural_Shiplap.png"
                },
                {
                  name: "Navy",
                  baseStainId: 14,
                  url: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/NavyShiplap.png",
                  thumbUrl: "//cdn.shopify.com/s/files/1/1976/5067/t/2/assets/NavyShiplap.png"
                },
                
              ];
                break;
            default:
                console.log('scriptType not found!! using nothing...');
        }
        
    },
    beforeDestroy() {
        if (typeof window !== "undefined") {
            window.removeEventListener("resize", this.onResize, { passive: true });
        }
    }
});


var ua = navigator.userAgent.toLowerCase();
if (ua.indexOf('safari') != -1) {
    if (ua.indexOf('chrome') > -1) {
        // Chrome
    } else {
        document.body.classList.add("safari"); // Safari
    }
}
          
          
          
